import React, { useContext } from 'react';
import Counter from "./Counter";
import { Link } from "react-router-dom";
import swalWithBootstrapButtons from "sweetalert2";
import Swal from "sweetalert2";
import { useAuth0 } from "@auth0/auth0-react";
import { StoreContext } from "../context";
import { useRecoilState } from "recoil";
import { cartItemsJSON, variantIndex } from "../states/atoms/store";
import { useTranslation } from "react-i18next";
import { favoriList } from "../states/atoms/products";

function FavoriList(props) {

    const { isAuthenticated, loginWithRedirect } = useAuth0();
    // const {cart, setCart} = useContext(StoreContext);
    const [favori, setFavori] = useRecoilState(favoriList);

    // eslint-disable-next-line
    const { t, i18n } = useTranslation();


    const handleClearCart = () => {
        return setFavori([]);
    };

    const handleDeleteItem = (index) => {

        // console.log("delete item",i);
        // console.log("Favorie",i);
        // return setFavori([]);
        if (!favori[index]) return;
        setFavori((favori) => favori.filter((_, i) => i !== index));
    };

    return (
        <section className="py-12">
            {i18n.language === "fr" ? (
                <div className="tw-container">
                    <article className="hidden lg:block py-10">
                        <div
                            className="grid text-center"
                            style={{ gridTemplateColumns: "1fr 1fr 1fr auto" }}
                        >
                            <h5>{t('panier.table.product')}</h5>
                            <h5>{t('panier.table.designation')}</h5>
                            <h5>{t('panier.table.unitPrice')}</h5>
                            <h5></h5>
                            <span className="w-8 h-8"></span>
                        </div>
                        <hr className="mt-6" />
                    </article>
                    {favori.map((item, i) => {
                        return (
                            <article
                                key={i}
                                className="grid cart-grid-cols-3 lg:cart-grid-cols-5 place-items-center mb-6 capitalize"
                                style={{ gridTemplateColumns: "1fr 1fr 1fr auto" }}
                            >
                                <div className="flex w-full gap-2 md:gap-4 items-center">

                                    <Link
                                        className="w-20"
                                        to={`/products/${item.id}`}
                                    >
                                        <img
                                            alt={item.name}
                                            className="object-cover w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-md"
                                            src={item.image}
                                        />
                                    </Link>

                                    <div>
                                        <h5 className="text-base md:text-lg lg:text-xl font-semibold">
                                            {t('favori.reference')}
                                        </h5>
                                        <div className="flex items-center gap-2 text-sm lg:text-base">
                                            {item.refernce}
                                        </div>
                                    </div>
                                </div>
                                <h5 className="hidden lg:block">
                                    {item.name}
                                </h5>
                                <h5 className="hidden lg:block">
                                    {item.prix}.00 Da
                                </h5>
                                <button
                                    className="block ml-3 md:ml-0 w-7 h-7 p-2 bg-red-600 text-white rounded"
                                    onClick={() => handleDeleteItem(i)}
                                >
                                    <svg
                                        stroke="currentColor"
                                        fill="currentColor"
                                        strokeWidth="0"
                                        viewBox="0 0 448 512"
                                    >
                                        <path
                                            d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path>
                                    </svg>
                                </button>
                            </article>
                        );
                    })}
                    <hr className="mt-10" />
                    <div className="flex justify-between py-8">
                        <button
                            onClick={handleClearCart}
                            className="btn-sm font-bold text-red-900 bg-red-300 transition hover:bg-red-900 hover:text-red-300 px-4 rounded-lg"
                        >
                            {t('favori.clear')}
                        </button>
                    </div>
                </div>
            ) : (
                <div className="tw-container">
                    <article className="hidden lg:block py-10">
                        <div
                            className="grid text-center"
                            style={{ gridTemplateColumns: "1fr 1fr 1fr auto" }}
                        >
                            <h5>{t('panier.table.product')}</h5>
                            <h5>{t('panier.table.designation')}</h5>
                            <h5>{t('panier.table.unitPrice')}</h5>
                            <h5></h5>
                            <span className="w-8 h-8"></span>
                        </div>
                        <hr className="mt-6" />
                    </article>
                    {favori.map((item, i) => {
                        return (
                            <article
                                key={i}
                                className="grid cart-grid-cols-3 lg:cart-grid-cols-5 place-items-center mb-6 capitalize"
                                style={{ gridTemplateColumns: "1fr 1fr 1fr auto" }}
                            >
                                <div className="flex w-full gap-2 md:gap-4 items-center">
                                    <Link
                                        className="w-20"
                                        to={`/products/${item.id}`}
                                    >
                                        <img
                                            alt={item.name}
                                            className="object-cover w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-md"
                                            src={item.image}
                                        />
                                    </Link>
                                    <div>
                                        <h5 className="text-base md:text-lg lg:text-xl font-semibold">
                                            {t('favori.reference')}
                                        </h5>
                                        <div className="flex items-center gap-2 text-sm lg:text-base">
                                            {item.refernce}
                                        </div>
                                    </div>
                                </div>
                                <h5 className="hidden lg:block">
                                    {item.name}
                                </h5>
                                <h5 className="hidden lg:block">
                                    {item.prix}.00 Da
                                </h5>
                                <button
                                    className="block ml-3 md:ml-0 w-7 h-7 p-2 bg-red-600 text-white rounded"
                                    onClick={() => handleDeleteItem(i)}
                                >
                                    <svg
                                        stroke="currentColor"
                                        fill="currentColor"
                                        strokeWidth="0"
                                        viewBox="0 0 448 512"
                                    >
                                        <path
                                            d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path>
                                    </svg>
                                </button>
                            </article>
                        );
                    })}
                    <hr className="mt-10" />
                    <div className="flex justify-between py-8">
                        <button
                            onClick={handleClearCart}
                            className="btn-sm font-bold text-red-900 bg-red-300 transition hover:bg-red-900 hover:text-red-300"
                        >
                            {t('panier.clear')}
                        </button>
                    </div>

                </div>
            )}

        </section>
    );
}

export default FavoriList;